import { SearchSessionsRequest, SessionResult } from '../../common/types';
import { SessionsResponse, ApplicationSessionPayload } from '../types';
import appClient from '../../common/services/AppClient';
import { endpoints } from '../../../config';

export default class SessionsServce {
    async searchSessions(request: SearchSessionsRequest): Promise<SessionsResponse> {
        let {
            projectId,
            search,
            pageSize,
            page,
            fieldsSearch,
            dates,
            appName,
            sortDirection,
            currentSortedField,
            userName
        } = request;

        if (!fieldsSearch) {
            fieldsSearch = {};
        }

        if (dates.length) {
            fieldsSearch.dateFilter = { dates: { first: dates[0], second: dates[1] } };
        }

        if (appName) {
            fieldsSearch.appFilter = { appName: appName };
        }

        if (userName) {
            fieldsSearch.userFilter = { userName: userName };
        }

        const url = `${endpoints.manageUrl}IotaRuntime/applications/sessions/search`;
        const result = await appClient.post<{ result: SessionResult[]; pageInfo: { total: number } }>(url, {
            projId: projectId,
            searchTerm: !search || search.length === 0 ? null : search,
            pageSize,
            page: page || 0,
            fieldsSearch: fieldsSearch || null,
            sortDirection: sortDirection,
            currentSortedField: currentSortedField
        });
        const data = result.unwrapOr({ result: [], pageInfo: { total: 0 } });

        var response = new SessionsResponse();
        response.total = data.pageInfo.total;
        response.lines = data.result;
        response.lines.forEach(r => {
            r.created = new Date(r.created).toUTCString();
            r.updated = new Date(r.created).toUTCString();
        });
        return response;
    }

    async getSessions(projectId: string): Promise<SessionResult[]> {
        const url = `${endpoints.manageUrl}IotaRuntime/applications/sessions?projectId=${encodeURIComponent(projectId)}`;
        const result = await appClient.get<SessionResult[]>(url);
        return result.unwrapOr([]);
    }

    async getSessionById(sessionId: string): Promise<SessionResult | null> {
        const url = `${endpoints.manageUrl}IotaRuntime/applications/sessions/${encodeURIComponent(sessionId)}`;
        const result = await appClient.get<SessionResult | null>(url);
        return result.unwrapOr(null);
    }

    async getApplicationNames(projectId?: string) {
        if (!projectId) {
            return [];
        }

        const url = `${endpoints.manageUrl}IotaRuntime/applications/application-names?projectId=${encodeURIComponent(projectId)}`;
        const result = await appClient.get<Array<{ applicationName: string }>>(url);
        return result.unwrapOr([]).map(x => x.applicationName);
    }

    async getApplicationSessionPayloads(sessionId: string) {
        const url = `${endpoints.manageUrl}IotaRuntime/applications/sessions/${encodeURIComponent(sessionId)}/payloads`;
        const result = await appClient.get<ApplicationSessionPayload[]>(url);
        return result.unwrapOr([]);
    }
}
